export const resolveUrl = (url = "") => {
  if (!url) return "";
  if (url.startsWith("/api")) return `${process.env.REACT_APP_BACKEND_URL}${url}`;
  return url;
};
